import { getTrackingId } from 'node_modules/@brighte/passwordless-authenticator/src/utils';
import React, { Suspense, useEffect } from 'react';
import { useAuth0 } from '@brighte/passwordless-authenticator';
import { usePrepop } from '@hooks';
import { HeadContent, Outlet, useNavigate } from '@tanstack/react-router';
import { handleNavigation } from './helper';

const TanStackRouterDevtools =
  process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test'
    ? () => null // Render nothing in production
    : React.lazy(() =>
        // Lazy load in development
        import('@tanstack/router-devtools').then(res => ({
          default: res.TanStackRouterDevtools,
        })),
      );

export function Pages() {
  const trackingId = getTrackingId();
  const { data: quote } = usePrepop({ trackingId });
  const { verificationCompleted } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (verificationCompleted) {
      handleNavigation({
        navigate,
        trackingId,
        quoteStatus: quote?.status,
        hasOpportunityId: !!quote?.opportunity?.id,
        financialProductId: quote?.financialProduct.id,
      });
    } else {
      const search = trackingId
        ? {
            trackingId,
          }
        : undefined;

      navigate({ to: '/connect/login/', search });
    }
  }, [navigate, trackingId, quote, verificationCompleted]);

  return (
    <>
      <HeadContent />
      <Outlet />
      <Suspense>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense>
    </>
  );
}
